import type { ReactNode } from 'react';
import { ShowcaseSection } from './ShowcaseSection';

interface ShowcasePreviewSectionProps {
  componentName: string;
  children: ReactNode;
}

export function ShowcasePreviewSection({
  componentName,
  children,
}: Readonly<ShowcasePreviewSectionProps>) {
  return (
    <ShowcaseSection
      title="Interactive Preview"
      description={`Use the Props Playground to customize this ${componentName}`}
    >
      {children}
    </ShowcaseSection>
  );
}
